import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateIncidents = document.createElement('template');

templateIncidents.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-1-3-ratio">
    <h2 class="widget-title display-2">
       <span id="incidentsStatusTitle"></span>
       ${renderErrorStateIcon()}
    </h2>

    <div class="content incidents-breakdown-container">
      <div class="chart-content">
          <div id="incidentsStatusChart" class="incidents-chart"></div>
          <div class="chart-empty donut-chart-error"><span class="display-1">--</span></div>
      </div>

        <div class="chart-legend">
          <div class="widget-missing-license text-center">
              <gz-text id="incidentsNotAvailableMessage" fontSize="12"></gz-text>
          </div>

          <div class="widget-missing-msp-license text-center">
              <gz-text id="incidentsNotAvailableMspMessage" fontSize="12"></gz-text>
          </div>

          <ul id="incidentsStatusList" class="list-unstyled incidents-list">
            <li class="gz-data-item" gz-incidents="investigatingIncidents">
                <span class="gz-data-item--bullet" gz-list-element="incidentColor"></span>

                <div class="gz-data-item--details item-details">
                    <div class="gz-data-item--title" gz-list-element="incidentName"></div>
                    <span class="gz-data-item--value" gz-list-element="incidentValue"></span>
                </div>
            </li>
            <li class="gz-data-item" gz-incidents="partiallyBlockedIncidents">
                <span class="gz-data-item--bullet" gz-list-element="incidentColor"></span>

                <div class="gz-data-item--details item-details">
                    <div class="gz-data-item--title" gz-list-element="incidentName"></div>
                    <span class="gz-data-item--value" gz-list-element="incidentValue"></span>
                </div>
            </li>
            <li class="gz-data-item" gz-incidents="blockedIncidents">
                <span class="gz-data-item--bullet" gz-list-element="incidentColor"></span>

                <div class="gz-data-item--details item-details">
                    <div class="gz-data-item--title" gz-list-element="incidentName"></div>
                    <span class="gz-data-item--value" gz-list-element="incidentValue"></span>
                </div>
            </li>
        </ul>
      </div>
      <gz-loader class="widget-loading" rows="5"></gz-loader>
    </div>
  </div>
`;
